var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5337_31810",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 7.41157 15.9365 6.83798 15.8159 6.28571H8V9.6H12.4054C11.7516 11.4 10.0259 12.6857 8 12.6857C5.41215 12.6857 3.31429 10.5878 3.31429 8C3.31429 5.41215 5.41215 3.31429 8 3.31429C9.31909 3.31429 10.5109 3.85935 11.3624 4.73654L13.6945 2.38108C12.2439 0.911091 10.2284 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5337_31810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.14258 8.0293L0.000278782 3.65732L5.71456 8.11446L0.000279161 12.343L-5.14258 8.0293Z",
    fill: "#FEBD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.65723L6.45714 -2.79992L13.4286 -0.285631L16.4571 5.0858L7.82857 5.42865L5.71429 8.11437L0 3.65723Z",
    fill: "#FF4131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65723 5.94293L16.9144 5.71436L16.8001 9.82864L14.5144 14.7429L9.82866 11.0858L7.65723 10.0572V5.94293Z",
    fill: "#0286F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.3433L5.71429 8.11475L6.34286 10.9719L9.82857 11.0862L14.5143 14.7433L9.77143 16.8005L3.88571 16.4576L0 12.3433Z",
    fill: "#01A94D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.c97b08f571c6184be5fbffbb164a3adb.svg";
export { ForwardRef as ReactComponent };